import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AudioSettings = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20, fill = 'none' }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 19 18"
        fill={fill}
        ref={forwardedRef}
      >
        <path
          d="M1.03613 2.90608L9.49978 2.90608M1.03613 8.9999H9.49978M9.49978 8.9999V11.0312M9.49978 8.9999V6.96863M1.03613 15.0937H5.26795M9.49978 15.0937L17.9634 15.0937M13.7316 8.9999H17.9634M13.7316 2.90608L17.9634 2.90608M13.7316 2.90608V4.93735M13.7316 2.90608V0.874802M5.79693 17.125V13.0624"
          stroke={color}
          strokeOpacity="0.8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default AudioSettings
